// extracted by mini-css-extract-plugin
export default {"p":"styles_p__Y4iOt","span":"styles_span__9OfM2","a":"styles_a__sr2P9"};